import { FilterOutlined } from "@ant-design/icons";
import { Flex, SelectProps } from "antd";
import { AssignmentType } from "tm-shared/types";

import { ASSIGNMENT_VOCABULARY } from "@/constants/ui/assignment";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setAssignmentsFilter } from "@/store/slices/ui";

import { StyledContainer, StyledSelect } from "./Styled";

const FILTER_OPTIONS = Object.values(ASSIGNMENT_VOCABULARY);

export const AssignmentFilter = () => {
    const dispatch = useAppDispatch();

    const { filter: currentFilter } = useAppSelector(
        (s) => s.ui.assignments.page,
    );

    const onFilterChange: SelectProps["onChange"] = (value) => {
        const v = (value ?? null) as AssignmentType | null;
        dispatch(setAssignmentsFilter(v));
    };

    const options = FILTER_OPTIONS.map(({ label, icon: Icon, value }) => ({
        label: (
            <Flex justify="flex-start" gap="12px" align="center">
                <Icon />
                <p>{label}</p>
            </Flex>
        ),
        value,
    }));

    return (
        <StyledContainer>
            <StyledSelect
                value={currentFilter}
                onChange={onFilterChange}
                listHeight={400}
                allowClear
                size="large"
                placeholder={
                    <Flex justify="flex-start" gap="12px" align="center">
                        <FilterOutlined />
                        <p>Тип доручення</p>
                    </Flex>
                }
                options={options}
            />
        </StyledContainer>
    );
};
